import { createReducer } from "reduxsauce";
import ModalActions from "modules/modal/modal-actions";

const INITIAL_STATE = {
  activeModalType: null
};

export const HANDLERS = {
  [ModalActions.Types.DISPLAY_MODAL]: (state, { activeModalType }) => ({
    ...state,
    activeModalType
  }),
  [ModalActions.Types.CLOSE_MODAL]: state => ({
    ...state,
    activeModalType: null
  })
};

export default createReducer(INITIAL_STATE, HANDLERS);



// WEBPACK FOOTER //
// ./src/modules/modal/modal-reducer.js